import React, { useEffect, useState } from "react";
import { Menu, X, Ship, Phone } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../data";
import { openEnquiry } from "./common";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.assign("/" + href);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-vivid-base/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" data-testid="logo-link" onClick={(e) => { e.preventDefault(); go("#top"); }} className="flex items-center gap-2">
          <Ship className="h-7 w-7 text-vivid-magenta" />
          <div className="leading-none">
            <span className="block font-heading text-lg font-extrabold tracking-tight">Vivid Cruises Sydney</span>
            <span className="block text-[10px] uppercase tracking-[0.25em] text-vivid-cyan">Vivid Sydney 2027</span>
          </div>
        </a>

        <div className="hidden items-center gap-7 lg:flex">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.replace('#','')}`}
              onClick={() => go(l.href)}
              className="text-sm text-white/75 transition-colors hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-enquire-btn"
            onClick={() => openEnquiry("General")}
            className="hidden items-center gap-2 text-sm text-white/80 transition-colors hover:text-white sm:inline-flex"
          >
            <Phone className="h-4 w-4" /> Enquire
          </button>
          <button
            data-testid="nav-book-now-btn"
            onClick={() => go("#tickets")}
            className="rounded-full bg-vivid-magenta px-5 py-2.5 text-sm font-medium text-white shadow-[0_0_20px_rgba(255,0,122,0.4)] transition-all hover:bg-vivid-magentaHover hover:-translate-y-0.5"
          >
            Book Now
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-white"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-vivid-base/95 backdrop-blur-xl border-t border-white/10 px-5 py-4">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="block w-full py-3 text-left text-white/80 border-b border-white/5"
            >
              {l.label}
            </button>
          ))}
          <button onClick={() => { setOpen(false); openEnquiry("General"); }} className="mt-3 w-full rounded-full border border-white/15 py-3 text-white/90">
            Enquire · {CONTACT.email}
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
